/**
 * Copyright (c) 2017 Comeon. All rights reserved. Company Confidential.
 */
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create; // creates basic elements not inserted into the dom
const nodetree = core.nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
const addNewCardAttr = 'addnewcard';
let textkeysObj = {};
function createSelectMethod(eventFilter) {
	const cName = `${eventFilter} payment__select-skrillaccount`;
	return create({
		type: 'select',
		class: cName
	});
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	/* this handler is a wrapper that filters out values from the target element,
	 and then applies the callback-argument on these values */
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		/* get method from the selectbox */
		const selectElm = p.elm;
		const selectedOptionIndex = selectElm.selectedIndex;
		const optionElm = selectElm[selectedOptionIndex];
		const value = optionElm.value;
		const text = optionElm.text;
		onEventCb({
			value,
			text
		});
		actions.viewSelectSkrillAccount(value);
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameHide);
		core.addClass(elm, classnameShow);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function createOptions(objById) {
	const nodes = [];
	const options = {};
	if (objById) {
		Object.keys(objById).forEach((key) => {
			options[key] = create({
				type: 'option',
				class: 'payment__option-lastused',
				value: objById[key].id
			});
			if (objById[key].selected) {
				options[key].selected = true;
			}
			options[key].innerHTML += objById[key].email;
			nodes.push(options[key]);
		});
	} else {
		console.warn('view_selectskrillaccount:createOptions: can not get last details in object: missing property "by_id"', objById);
	}
	return nodes;
}

function createOptionForAdd(text, addAttribute) {
	const elm = create({
		type: 'option',
		class: 'payment__option-lastused',
		add: 'add',
		value: addAttribute
	});
	if (text) {
		elm.innerHTML = text;
	}
	return elm;
}

export default {
	create(p) {
		textkeysObj = viewTextkeys.depositflow();
		let elements = {};
		const mainEventType = 'change';
		const classNameEventFilter = 'js-eventfilter-viewselectskrillaccount';
		const callbackOnMainEvent = (p.callbackonmainevent || function temp() {});
		elements.wrap = (elements.wrap || createSelectMethod(classNameEventFilter));
		const handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update(state) {
				const accounts = (state.fetch_methoddetails && state.fetch_methoddetails.accounts);
				const accountByIdList = (accounts && accounts.by_id);
				const lastUsedAccountIdx = state.fetch_methoddetails.lastUsedAccountIdx;
				if (accountByIdList && !elements.options) {
					elements.options = createOptions(accountByIdList);
					elements.options.push(createOptionForAdd(textkeysObj['skrill-account-dropdown-add-account-placeholder'], addNewCardAttr));
					elements.wrap.appendChild(nodetree(elements.options));
				} else if (lastUsedAccountIdx) {
					elements.options[lastUsedAccountIdx].selected = true;
				}
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				 Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_selectskirllaccount:139');
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-selectskrillaccount.js